import api, { PaginatedResponse, PaginationParams } from '@/config/api';

/**
 * Fetch a paginated resource.
 */
export async function fetchPaginated<T>(
  url: string,
  params?: PaginationParams & Record<string, unknown>,
): Promise<PaginatedResponse<T>> {
  const { data } = await api.get<PaginatedResponse<T>>(url, { params });
  return data;
}

/**
 * Fetch a single resource.
 */
export async function fetchOne<T>(url: string): Promise<T> {
  const { data } = await api.get<T>(url);
  return data;
}

/**
 * Fetch an endpoint that may return a plain array and wrap it in PaginatedResponse shape.
 */
export async function fetchList<T>(
  url: string,
  params?: Record<string, unknown>,
): Promise<PaginatedResponse<T>> {
  const { data } = await api.get<T[]>(url, { params });
  const items = Array.isArray(data) ? data : [];
  return { items, total: items.length, page: 1, page_size: items.length, pages: 1 };
}

export { api };
export type { PaginatedResponse, PaginationParams };
